export function formatDocumentTitle(title?: string | null): string {
  return title?.trim() ? title : '-';
}